import ApiService from "@/api/baseApi/api-service";
import { Config } from "../../config";
import {
  IContactUSParams,
  IPostContactUS,
} from "./interfaces/api-contactus-interfaces";

const subBaseUrl = "/contact-us";

const URLs = {
  contactUs: subBaseUrl, //post
};
class ApiContactUs extends ApiService {
  constructor(config: Config) {
    super({ ...config });
  }
  contactUs = (
    body: IContactUSParams,
    params?: {
      fbc?: string | null;
      fbp?: string | null;
      event_id?: string;
      ttp?: string | null;
      ttclid?: string | null;
      twclid?: string | null;
    },
  ): Promise<IPostContactUS> => this.post(URLs.contactUs, { ...body }, { params });
}
export default ApiContactUs;
